import { render, staticRenderFns } from "./solicitacoes.vue?vue&type=template&id=2c95c342&scoped=true&"
import script from "./solicitacoes.vue?vue&type=script&lang=js&"
export * from "./solicitacoes.vue?vue&type=script&lang=js&"
import style0 from "./solicitacoes.vue?vue&type=style&index=0&id=2c95c342&prod&lang=scss&scoped=true&"
import style1 from "./solicitacoes.vue?vue&type=style&index=1&id=2c95c342&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c95c342",
  null
  
)

export default component.exports